import script from "./AboutSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutSection.vue?vue&type=script&setup=true&lang=js"

import "./AboutSection.vue?vue&type=style&index=0&id=41cf5263&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-web-portfolio/vue-web-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41cf5263"]])

export default __exports__